import React from 'react';

const features = [
  'Already trusted',
  'Easy transaction',
  'Family friendly',
  'Memorable experiences',
  'Many games',
  'Latest game engine',
  'Updated game types',
  'Pro shop available',
];

function About() {
  return (
    <section className="about section-padding" id="about">
      <div className="container">
        <div className="about-content">
          <h5>About Us</h5>
          <h2>We Are Best Game Center in Town</h2>
          <p>
            Located in the heart of the beautiful Poconos, SkyLanes Bowling Center is a premier
            entertainment destination. We offer state-of-the-art bowling lanes, a fully stocked
            pro shop, delicious food and drinks, and an exciting arcade for guests of all ages.
            Whether you're looking for family fun or a competitive league experience, we've got
            you covered.
          </p>
          <div className="feature-list">
            {features.map((feature, index) => (
              <div className="feature-item" key={index}>
                <span className="check-icon">✓</span>
                <span>{feature}</span>
              </div>
            ))}
          </div>
          <a href="#contact" className="btn">About Us</a>
        </div>
        <div className="about-image">
          <img
            src="/images/skylane1.jpg"
            alt="SkyLanes Bowling Center lanes in East Stroudsburg PA"
            loading="lazy"
          />
          <img
            src="/images/skylane2-1.jpg"
            alt="SkyLanes Bowling Center interior and arcade area"
            loading="lazy"
            className="overlay-img"
          />
        </div>
      </div>
    </section>
  );
}

export default About;
